import { Component } from '@mycolorway/tao';
import 'next/stylesheets/components/project/creation/form.scss';

Component('tr-project-creation-form', {
  ready() {
    window.tower.projectBadge({ target: 'tr-project-creation-form .btn-change-project-badge .badge' });
    this.querySelector('.name-form-input input[type="text"]').focus();
  },
});
